<template>
  <div class="upload-one">
    <el-upload
      class="avatar-uploader"
      accept="image/*"
      ref="uploader"
      :action="uploadImage"
      :on-error="uploadError"
      :on-exceed="uploadExc"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-upload="beforeUpload"
      :headers="headers"
      :on-success="uploadSuccessOne"
      list-type="picture"
      :show-file-list="false"
      :disabled="ifDisable"
    >
      <img v-if="picUrl" :src="picUrl" class="avatar" />
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <el-button
      v-if="!noNeedDefaultImg"
      type="primary"
      size="small"
      @click="dialogShow = true"
    >
      使用默认图
    </el-button>
    <div v-if="!noNeedDefaultImg" class="tip" slot="tip">
      * 请上传 3.5:1 比例的图片 (最小宽高 700px:200px)
    </div>
    <CanvasDialog
      v-if="dialogShow"
      @dialog-close="dialogClose"
      @dialog-confirm="dialogConfirm"
    ></CanvasDialog>
  </div>
</template>

<script>
import { upLoadImg } from '@/Mixin/upLoadImg';
import { uploadImage } from '@/api/ajax';
import CanvasDialog from './CanvasDialog';
export default {
  props: {
    ifDisable: {
      type: Boolean,
      default: false
    },
    initDone: {
      // 外层初始化完毕
      type: Boolean,
      default: false
    },
    initUrl: {
      // 初始化图片
      type: String,
      default: ''
    },
    noNeedDefaultImg: false
  },
  mixins: [upLoadImg],
  data() {
    return {
      dialogShow: false,
      uploadImage,
      picUrl: ''
    };
  },
  methods: {
    beforeUpload(file) {
      if (file.name) {
        const fileTypeList = ['jpg', 'jpeg', 'png', 'webg', ''];
        let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (!fileTypeList.includes(testmsg)) {
          this.$notify({
            type: 'error',
            message: '上传类型有误'
          });
          return false;
        }
      }
    },
    saveImg() {
      /**
       * [if description]
       * @param  {[uploadImgList]}  初始化数据 响应初始化 添加 删除
       * @param {[picUrl]}      uploadImgList 最后转化为 picUrl 的值
       */

      if (this.uploadImgList) {
        let len = this.uploadImgList.length;
        if (this.uploadImgList[len - 1].upLoadUrl) {
          // 初始化的图片
          this.picUrl = this.uploadImgList[len - 1].upLoadUrl;
          // this.$set(this, 'picUrl', this.uploadImgList[len - 1].upLoadUrl)
        } else if (this.uploadImgList[len - 1].response.data) {
          // 上传后的图片
          this.picUrl = this.uploadImgList[len - 1].response.data;
        }
      }
    },
    uploadSuccessOne(response, file, fileList) {
      this.uploadImgList = fileList;
      this.saveImg();
      this.$emit('upload-done', this.picUrl);
    },
    dialogClose() {
      this.dialogShow = false;
    },
    dialogConfirm(blob) {
      this.$refs.uploader.handleStart(blob);
      this.$refs.uploader.submit();
      this.dialogShow = false;
    }
  },
  components: {
    CanvasDialog
  },
  computed: {},
  mounted() {},
  watch: {
    initDone(v) {
      if (v) {
        this.getImgList(this.initUrl);
        this.saveImg();
      }
    },
    initUrl: {
      handler(v) {
        if (v) {
          this.getImgList(v);
          this.saveImg();
        }
      },
      immediate: true
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.tip {
  font-size: 14px;
  color: #dd1919;
}
</style>
